import { gql } from '@/__generated__/gateway';

export const productReviewsQuery = gql(`
  query productReviews($input: ListProductReviewInput!) {
    productReviews {
      listReviews(input: $input) {
        cursor
        reviews {
          rating
          id
          translated {
            title
            body_text
            language
          }
          original {
            title
            body_text
            language
          }
          author {
            avatar_url
            display_name
            name
            username
          }
          created_at
          published_at
        }
      }
    }
  }
`);
